import { __assign, __awaiter, __decorate, __generator, __metadata } from "tslib";
import { action, observable } from 'mobx';
import { toSentenceCase } from '../services/helper';
var SummaryStore = (function () {
    function SummaryStore(rootStore) {
        var _this = this;
        this.rootStore = rootStore;
        this.sections = [];
        this.minimumTotalCost = 0;
        this.totalAmountowing = 0;
        this.termsAndConditions = '';
        this.loading = false;
        this.termsAndConditionsDetails = null;
        this.contractCode = '';
        this.nbnEslaService = false;
        this.hardwareCode = '';
        this.nbnLocId = '';
        this.voipCode = '';
        this.resetSummary = function () {
            _this.sections = [];
            _this.contractCode = '';
            _this.minimumTotalCost = 0;
            _this.totalAmountowing = 0;
            _this.termsAndConditionsDetails = _this.getInitialStoreState();
        };
        this.getInitialStoreState = function () { return ({
            formInitialValues: _this.getInitialFormValues(),
            formValues: null,
        }); };
        this.getInitialFormValues = function () { return ({
            termsAndConditions: false,
        }); };
        this.termsAndConditionsDetails = this.getInitialStoreState();
    }
    SummaryStore.prototype.setDetailsFromForm = function (details) {
        this.termsAndConditionsDetails.formValues = details;
    };
    SummaryStore.prototype.setNbnEslaServiceValue = function (val) {
        this.nbnEslaService = val;
    };
    SummaryStore.prototype.getSummary = function (contractCode, hardwareCode, nbnLocId, voipCode, discountAmount, nbnEslaService) {
        return __awaiter(this, void 0, void 0, function () {
            var wholesaleCustomerCode, planDetails, summaryRequest, version;
            var _this = this;
            return __generator(this, function (_a) {
                this.loading = true;
                wholesaleCustomerCode = this.rootStore.config.wholesaleCustomerCode;
                planDetails = this.rootStore.planStore.planDetails.formValues;
                this.contractCode = contractCode;
                this.nbnEslaService = this.nbnEslaService;
                this.hardwareCode = hardwareCode;
                this.nbnLocId = nbnLocId;
                this.voipCode = voipCode;
                summaryRequest = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ contractCode: contractCode, nbnEslaService: nbnEslaService, discountAmount: discountAmount }, (wholesaleCustomerCode === 'OT' ||
                    wholesaleCustomerCode === 'TOM' ||
                    wholesaleCustomerCode === 'ISPX' ||
                    wholesaleCustomerCode === 'PB'
                    ? {
                        hardwareCodes: Object.values(hardwareCode).filter(function (val) { return val; }),
                    }
                    : { hardwareCode: hardwareCode })), { includeTermsAndConditions: true, nbnLocId: nbnLocId }), (this.rootStore.saleStore.promo &&
                    this.rootStore.saleStore.promo.success && {
                    promoCode: this.rootStore.saleStore.promoCode,
                })), { voipCode: voipCode, voipExistingServiceNumber: planDetails && planDetails.existingNumber
                        ? planDetails.numberToPort
                        : '', voipHardwareCode: '', newDevelopmentChargeApplies: this.rootStore.checkAddressStore
                        .newDevelopmentsChargeApplies }), (this.rootStore.checkAddressStore.newDevelopmentsChargeApplies && {
                    newDevelopmentCharge: this.rootStore.checkAddressStore
                        .newDevelopmentsCharge,
                })), { newConnectionChargeApplies: this.rootStore.checkAddressStore
                        .newConnectionChargeApplies }), (this.rootStore.checkAddressStore.newConnectionChargeApplies && {
                    newConnectionCharge: this.rootStore.checkAddressStore
                        .newConnectionCharge,
                })), { formattedAddress: this.rootStore.checkAddressStore.formattedAddress, serviceClass: this.rootStore.checkAddressStore.serviceClass });
                version = wholesaleCustomerCode === 'OT' ||
                    wholesaleCustomerCode === 'TOM' ||
                    wholesaleCustomerCode === 'ISPX' ||
                    wholesaleCustomerCode === 'PB'
                    ? 'V2'
                    : 'V1';
                this.rootStore.api[version].Sale.Order.Summary(summaryRequest).then(function (r) {
                    _this.sections = [];
                    _this.termsAndConditions = r.termsAndConditions;
                    r.sections.forEach(function (section) {
                        if (section.title === 'Minimum Total Cost') {
                            _this.minimumTotalCost = section.amountOwing;
                        }
                        else {
                            if (_this.rootStore.config.wholesaleCustomerCode === 'OT' ||
                                _this.rootStore.config.wholesaleCustomerCode === 'ISPX' ||
                                _this.rootStore.config.wholesaleCustomerCode === 'PB') {
                                toSentenceCase(section.title);
                            }
                            _this.sections.push(section);
                        }
                    });
                    _this.loading = false;
                });
                this.loading = false;
                return [2];
            });
        });
    };
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], SummaryStore.prototype, "sections", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], SummaryStore.prototype, "minimumTotalCost", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], SummaryStore.prototype, "totalAmountowing", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SummaryStore.prototype, "termsAndConditions", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], SummaryStore.prototype, "loading", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], SummaryStore.prototype, "termsAndConditionsDetails", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SummaryStore.prototype, "contractCode", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], SummaryStore.prototype, "nbnEslaService", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], SummaryStore.prototype, "hardwareCode", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SummaryStore.prototype, "nbnLocId", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], SummaryStore.prototype, "voipCode", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SummaryStore.prototype, "setDetailsFromForm", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SummaryStore.prototype, "setNbnEslaServiceValue", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object, String, String, Number, Boolean]),
        __metadata("design:returntype", Promise)
    ], SummaryStore.prototype, "getSummary", null);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], SummaryStore.prototype, "resetSummary", void 0);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], SummaryStore.prototype, "getInitialStoreState", void 0);
    return SummaryStore;
}());
export { SummaryStore };
//# sourceMappingURL=SummaryStore.js.map